import { render, staticRenderFns } from "./order-type-for-manual-return.vue?vue&type=template&id=701bdfca&scoped=true&"
import script from "./order-type-for-manual-return.vue?vue&type=script&lang=js&"
export * from "./order-type-for-manual-return.vue?vue&type=script&lang=js&"
import style0 from "./order-type-for-manual-return.vue?vue&type=style&index=0&id=701bdfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701bdfca",
  null
  
)

export default component.exports